import { makeStyles } from 'tss-react/mui';
import {
  Card, CardContent, Skeleton, Typography,
} from '@mui/material';

const useStyles = makeStyles()((theme) => ({
  root: {
    borderRadius: theme.radii.large,
    position: 'relative',
    backgroundColor: theme.palette.info.xlight,
    flex: 'none',

    [theme.breakpoints.down('md')]: {
      width: '100%',
    },
  },
}));

export const ReviewSkeleton = () => {
  const { classes } = useStyles();

  return (
    <Card className={classes.root}>
      <CardContent>
        <Typography
          variant="overline"
          color="textSecondary"
          gutterBottom
        >
          <Skeleton />
        </Typography>

        <Typography
          color="textSecondary"
          gutterBottom
        >
          <Skeleton />
        </Typography>

        <Typography
          variant="body2"
          color="textSecondary"
        >
          <Skeleton />
        </Typography>
      </CardContent>
    </Card>
  );
};
